/** @module HeaderSearchForm */
define([
	"dojo/_base/declare",
	"dojo/_base/event",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-style",
	"dojo/mouse",
	"dojo/on",
	"dojo/query",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetsInTemplateMixin",
	"dijit/form/Form",
	"dgrid/OnDemandGrid",
	"dgrid/Selection",
	"dgrid/extensions/DijitRegistry",
	"underscore",
	"csi",
	"csi/_base/storage",
	"csi/access/crews",
	"csi/action",
	"csi/config/preferences",
	"csi/def/Action",
	"csi/html",
	"csi/page/SearchManager",
	"csi/locale",
	"csi/reflection",
	"csi/state/rootStore",
	"csi/store/_base",
	"csi/store/Cache",
	"csi/store/Names",
	"csi/store/Nodes",
	"csi/xml",
	"csi/xml/Query",
	"dojo/text!csi/page/HeaderSearchForm.html",

	/* controls used in html template */
	"csi/widget/Select",
	"dijit/form/ToggleButton",
	"dijit/form/TextBox",
	"dijit/form/Button",
	"dijit/layout/ContentPane"
], function(declare, event, lang, domClass, domStyle, mouse, on, dojoQuery, _TemplatedMixin, _WidgetsInTemplateMixin, Form,
	OnDemandGrid, Selection, GridDijitRegistry, _, csi, storage, crews, csiAction, configPreferences, Action,
	html, SearchManager, locale, reflection, {featureTogglesStore}, csiStore, Cache, Names, Nodes, xml, Query, template) {

	var STORAGE_KEY = "SearchScope";
	
	var SEARCH_IN_ARCHIVE_ID = "Archive";
	

	return declare([Form, _TemplatedMixin, _WidgetsInTemplateMixin], {
		templateString: template,

		// connection points
		scopeNode: null,
		statusNode: null,
		textNode: null,

		/** @property {string} searchType - type of node selected for global search */
		searchType: null,

		/** @property {Nodes} store - store for global search */
		store: null,

		// csi.view.Widget: containing view
		view: null,

		// Object: event handle
		_handleSubscribe: null,
		_searchMouseOverStatus: true,

		// Boolean: flag to determine whether to open search results panel or not
		_openStatus: false,

		/** Search In store idProperty {string}  */
		_searchInIdProperty: '$',

		/** Search In store  labelProperty {string} */
		_searchInLabelProperty: 'Name',

		/** Search in path {string} */
		_searchInPath: '',

		/** Search In type {string} */
		_searchInType: '',
		
		/** Enable or disable search in Archive (boolean) */
		_searchInArchive: false,

		startup: function() {
			var s = storage.get(STORAGE_KEY);

			this.inherited(arguments);

			// set last selected scope from cookie
			var store = SearchManager.getTypeStore();
			var storeQuery = SearchManager.getTypeStoreQuery();
			var type = s ? s.scope : SearchManager.getFirstSearchType();

			const scopeNode = this.scopeNode;
			scopeNode.set("query", storeQuery);
			scopeNode.set("store", store);
			scopeNode.set("value", type);

			this._createSearchInGrid();

			// add events
			this.connect(dojo.global, "onmousedown", this._pageClickEvent);

			on(this.containerNode, mouse.enter, lang.hitch(this, function(evt) {
				this._searchMouseOverStatus = true;
			}));

			on(this.containerNode, mouse.leave, lang.hitch(this, function(evt) {
				this._searchMouseOverStatus = false;
			}));
			
			this._searchInArchive = featureTogglesStore.ENABLE_ARCHIVING && crews.isArchiveViewer(null);
		},

		_configureSearch: function() {
			// summary: configure search query
			var v = this.get("value");
			var text = v.headerSearchText.trim();
			var type = this.searchType;
			var rc = reflection.getClass(type);
			var depPaths = SearchManager.getSearchQueryPaths(type);
			var filterQuery = new Query();
			var sortQuery = SearchManager.getSearchTypeSortQuery(type);
			var q = filterQuery;
			var urlContext = this._searchInPath;
			var a2;

			if (text) {
				// add attributes to query based on display format
				var displayFormat = locale.getDisplayFormat(type);
				if (displayFormat) {
					// use Or condition if multiple attributes to query for
					if (displayFormat.a2) {
						q = filterQuery.Or();

						// if relation, make sure to include dependency path in query
						if (rc.getRelation(displayFormat.a2, true, true)) {
							depPaths.push(xml.pathCreate(xml.PATH_OP_CHILD, displayFormat.a2));
						}
					}

					// if relation, make sure to include dependency path in query
					if (rc.getRelation(displayFormat.a1, true, true)) {
						depPaths.push(xml.pathCreate(xml.PATH_OP_CHILD, displayFormat.a1));
					}

					// additional attribute is one that is not "Node Name"
					a2 = (displayFormat.a1 == xml.ATTR_NAME) ? displayFormat.a2 : displayFormat.a1;
				}

				q.Node(xml.PROP_NAME, xml.OP_MATCHES, text);

				// add filtering and sorting if display format specified
				if (a2) {
					q.Attr(a2, xml.OP_MATCHES, text);
				}
			}

			// filter by context if present and currently displayed
			if (xml.isValidURL(urlContext)) {
				const {pathToContext} = SearchManager.getSearchType(type);
				filterQuery.Node(xml.PROP_URL, xml.OP_EQUALS, urlContext, pathToContext);
			}

			// apply hard-coded filters by search type
			SearchManager.getSearchTypeQuery(type, filterQuery);


			// apply enforced user defaults based on search type
			configPreferences.applyUserDefaultsToQuery(filterQuery, type, null, function(ud) {
				return ud.enforced;
			});

			if (urlContext == SEARCH_IN_ARCHIVE_ID) {
				this.store = new Nodes({
					cachingStore: new Cache(),
					typeNode: type,
					requestModule: "Archive",
					requestOperation: "SearchInArchive",
					requestParameters: {
						"Dep.Path": depPaths,
						"Fmt.AC.Rights": "No",
						"Fmt.Complete.Max": "200",
						"UI_View": "Search",
						"Type": type,
						"Search_String": "%"+ text + "%",
						"Query_Dirty": true
					},
					_isDirty: function(/*Object*/query, /*Object*/options) {
						return true;
					}
				});
			} else {
				this.store = new Nodes({
					cachingStore: new Cache(),
					typeNode: type,
					filterQuery,
					sortQuery,
					requestParameters: {
						"Crew.Scope": "No",
						"Dep.Path": depPaths,
						"Fmt.AC.Rights": "No",
						"Fmt.Complete.Max": "200",
						"UI_View": "Search"
					}
				});
			}
		},

		_createSearchInGrid: function() {
			var self = this;
			const grid = this._searchInGrid = new declare([OnDemandGrid, Selection, GridDijitRegistry])({
				allowSelectAll: true,
				allowTextSelection: false,
				deselectOnRefresh: false,
				noDataMessage: locale.resource('SEARCH_NO_RESULTS'),
				selectionMode: 'single',
				showHeader: false,
				store: null,
				addUiClasses: false,
				columns: [
					{
						field: this._searchInLabelProperty,
						label: 'Name'
					}
				],
				renderRow: function(object, options) {
					if (object.$ == csi.EMPTY_URL) {
						var div = html.create('div', {'class': 'csi-header-search-dropdown-no-hover'});
						html.create('div', {innerText: 'Search In', 'class': 'csi-header-search-in-title'}, div);
						var div2 = html.create('div', {'class': 'csi-header-search-dropdown-hover'}, div);
						html.create('span', {'class': 'csiActionIcon iconSearchLight'}, div2);
						html.create('span', {'class': 'csi-header-search-in-title-label', innerText: object[this.store.labelProperty]}, div2);
						if (!self._searchInArchive) {
							html.create('div', {'class': 'csi-header-search-in-title-border'}, div);
						}
						return div;
					} if (object.$ == SEARCH_IN_ARCHIVE_ID) {
						var div = html.create('div', {'class': 'csi-header-search-dropdown-no-hover'});
						var div2 = html.create('div', {'class': 'csi-header-search-dropdown-hover'}, div);
						html.create('span', {'class': 'csiActionIcon iconSearchLight'}, div2);
						html.create('span', {'class': 'csi-header-search-in-title-label', innerText: object[this.store.labelProperty]}, div2);
						html.create('div', {'class': 'csi-header-search-in-title-border'}, div);
						return div;
					} else {
						var div = html.create('div', {'class': 'csi-header-search-dropdown-hover'});
						html.create('span', {'class': 'csiActionIcon iconSearchLight'}, div);
						html.create('span', {'class': 'csi-header-search-in-title-label', innerText: object[this.store.labelProperty]}, div);
						return div;
					}
				}
			}, this.searchInDropdownNode);

			grid.on('.dgrid-row:click', evt => {
				var row = grid.row(evt);
				var item = row.data;
				this._onChangeSearchIn(item);
				this._showSearchInDropDown(false);
				if (this._openStatus) {
					this.onSubmit();
				}
				this.textNode.focus();
			});

			grid.startup();
		},

		_showSearchInDropDown: function(show) {
			var displayMode = show ? 'block' : 'none';
			domStyle.set(this.searchInDropdownNode, {display: displayMode});
			this.searchInButtonNode.set('checked', show);
		},

		_showSearchResultsDropDown: function(show) {
			var displayMode = show ? 'block' : 'none';
			domStyle.set(this.searchResultsNode, {display: displayMode});
		},

		_pageClickEvent: function(/*Event?*/ e) {
			// summary: Closes the search results if clicked anywhere else on the page
			if (this._searchMouseOverStatus == false) {
				this._onCloseSearch();
			}
		},

		onSubmit: function( /*Event?*/ e) {
			// summary: configure search query
			if (e) event.stop(e);

			// Close searchIn panel
			this._showSearchInDropDown(false);

			// open search panel if not already open
			this._openStatus = true;
			this._onFocusText(e);

			// configure relationship for search options
			this._configureSearch();

			// execute search
			const searchAction = lang.mixin(new Action(), {
				m_id: "Search",
				classController: "csi/page/HeaderSearchController"
			});

			csiAction.invoke(this.view, this.scopeNode.domNode, searchAction, {actionWidget: this});
			return false;
		},

		resize: function() {
			this._resizeSearchTextNode();
		},

		_resizeSearchTextNode: function() {
			//Resize header search text box based on the width of scope selected
			var textNodeWidth = this.containerNode.offsetWidth - this.scopeNode.domNode.offsetWidth - this.searchInLabelNode.offsetWidth;
			html.setPixels(this.textNode.domNode, 'width', textNodeWidth);
		},

		_onChangeScope: function(nodeType) {
			// summary: update options based on selection
			const {pathToContext} = SearchManager.getSearchType(nodeType);

			this.searchType = nodeType;
			this._openStatus = false;
			this._onCloseSearch();
			this._searchInPath = '';
			this._searchInType = '';

			if (pathToContext) {
				const rc = reflection.getClass(nodeType);
				const rcContext = rc.getPathClass(pathToContext);
				if (rcContext) {
					const contextType = rcContext.getType();
					const {bContextSortByLatest} = SearchManager.getSearchType(contextType);
					const search = csiStore.searchByType(contextType);

					if (bContextSortByLatest) {
						search.getSortQuery().SortByNode(xml.PROP_CREATE_TIME, null, true);
					}
					
					var self = this;
					const storeSearchIn = new Names({
						bSort: !bContextSortByLatest,
						data: self._searchInArchive && self.searchType === "Style"  ? [csiStore.nameObject(locale.resource("SelectAll")), csiStore.nameObject(locale.resource("SelectArchive"), SEARCH_IN_ARCHIVE_ID)] : [csiStore.nameObject(locale.resource("SelectAll"))],
						request: search.getRequest(),
						typeNode: contextType
					});

					this._searchInType = contextType;
					this._searchInGrid.set('store', storeSearchIn);
					this._searchInIdProperty = storeSearchIn.idProperty;
					this._searchInLabelProperty = storeSearchIn.labelProperty;
					this._onChangeSearchIn();
				}
			}

			_.defer(() => {
				domStyle.set(this.searchInLabelNode, 'display', this._searchInType ? '' : 'none');
				this._resizeSearchTextNode();
			});

			this._showSearchResultsDropDown(false);
			this._updateCookie();
			this.textNode.focus();
		},

		_onChangeSearchIn: function(item) {
			if (item) {
				var val = item[this._searchInIdProperty];
				var name = item[this._searchInLabelProperty];
			} else {
				val = '';
				name = locale.resource('SelectAll');
			}
			this._searchInPath = val;
			this.searchInButtonNode.set('label', _.escape(name));
			this.searchInButtonNode.set('title', name);
			this._resizeSearchTextNode();
		},

		_onSearchInClick: function() {
			this._showSearchInDropDown(!html.isVisible(this.searchInDropdownNode));
		},

		_onClick: function( /*Event?*/ e) {
			// summary: close search panel if clicked on browse anchor, otherwise forward click to view
			if (e.target && domClass.contains(e.target, html.CSS_BROWSE)) {
				this._onCloseSearch();
			} else {
				this.view.onClick(e);
			}
		},

		_onHeaderSearchSelectClick: function() {
			this._showSearchInDropDown(false);
		},

		_onCloseSearch: function( /*Event?*/ e) {
			// summary: close search panel
			this._showSearchResultsDropDown(false);
			this._showSearchInDropDown(false);

			// do this to stop IE from passing event to onSubmit (not sure why)
			if (e) {
				event.stop(e);
			}
		},

		_onFocusText: function() {
			// summary: open search panel if not already
			if (!html.isVisible(this.searchResultsNode)) {
				if (this._openStatus) {
					this._showSearchResultsDropDown(true);
				}
			}
		},


		_updateCookie: function() {
			// summary: save localStorage/cookie for search panel
			storage.set(STORAGE_KEY, {
				scope: this.scopeNode.get("value")
			});
		},

		hideSearchResults: function() {
			this._onCloseSearch();
		}
	});
});
